import { createApp } from 'vue';
import EmbedBuilderModal from './EmbedBuilderModal.vue';
import { i18n } from '../../i18n';

if (document.querySelector('#embed-builder-app')) {
  const app = createApp(EmbedBuilderModal);
  app.use(i18n);
  app.mount('#embed-builder-app');
}
